/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Heading, Stack, Text, Divider } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { map, get } from 'lodash';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/app/shopify/navigation';
import AnnotatedSection from 'components/annotated-section';
import Card from 'components/card';
import Button from 'components/button';
import AnnotatedSectionSkeleton from 'components/skeleton-loader/annotated-section-skeleton';
import cecSdk from 'lib/app-ec-sdk';
import Notice from 'components/notice';
import { successNotice, errorNotice } from 'state/notices/actions';
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';

const AppUninstall = ({ uninstall, ...props }) => {
    const [requesting, setRequesting] = useState(true);
    const [error, setError] = useState(false);
    const [values, setValues] = useState({});

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            //setRequesting(true);
            //setError(null);
            const queryParameters = new URLSearchParams(window.location.search);

            const hmac = queryParameters.get("hmac");
            const host = queryParameters.get("host");
            const shop = queryParameters.get("shop");
            const timestamp = queryParameters.get("timestamp");
            const session = queryParameters.get("session");

            let response = await cecSdk.uninstall().verifyUninstall(hmac, host, session, shop, timestamp);

            // if(response.status == 200) {
            //     window.location.href = response.return_url;
            // }

            setValues(response);
        } catch (error) {
            setError(error.message);
        }

        setRequesting(false);
    };

    if (requesting) {
        return (
            <Main>
                <Stack space='large'>
                    <Navigation section='general' />
                    <AnnotatedSectionSkeleton />
                </Stack>
            </Main>
        );
    }

    return (
        <Main>
            <Stack space='large'>
                <Navigation section='general' />
                <Box paddingTop='xxlarge' paddingBottom='xxlarge'>
                    <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                        <Heading level='1'>App</Heading>
                    </Box>
                    <Divider />
                </Box>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Tower Web Connect'
                            description='This will uninstall Tower Web Connect app to your Shopify store.'
                        />
                        <AnnotatedSection.Content>
                            <Stack space='large'>
                                <Card>
                                    { (get(values, 'status') == 200) ?
                                    <Card.Section>
                                        <Stack space='large'>
                                            <Box>
                                                <FormLabel>Response {get(values, 'status')}</FormLabel>
                                                <Text className="card__section-uninstallinfo">Uninstall successful</Text>
                                            </Box>
                                        </Stack>
                                    </Card.Section>
                                    : 
                                    <Card.Section>
                                        <Stack space='large'>
                                            <Box>
                                                <FormLabel>Response</FormLabel>
                                                <Text className="card__section-uninstallinfo">Error occured when uninstall</Text>
                                            </Box>
                                            <Box>
                                            <Text size='small'>
                                                 {get(values, 'error')}
                                            </Text>
                                            </Box>
                                        </Stack>
                                    </Card.Section>
                                    }
                                </Card>
                            </Stack>
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Stack>

        </Main>
    );
};

export default connect(
    (state) => ({
        //locations: getAllLocations(state),
    }),
    {
        // requestLocations,
        // startEditingLocation,
        // deleteLocation,
        successNotice,
        errorNotice,
    },
)(AppUninstall);
